import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  
  selector: 'app-image-zoom',
  templateUrl: './image-zoom.component.html',
  styleUrls: ['./image-zoom.component.scss'],
})
export class ImageZoomComponent  implements OnInit {
  @ViewChild('swiper') swiperRef: ElementRef | undefined;

  // constructor() { }

  @Input() imageUrl: string = '';
  ngOnInit() {}

  constructor(private modalCtrl: ModalController) {}

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
